import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { SaleOrderBearingVisibility } from '../sale-order-bearing-visibility';

export class SaleOrderBearingVisibilityBuilder {
  static fromJson(json): SaleOrderBearingVisibility {
    return (json) ? new SaleOrderBearingVisibility(
      json.saleOrderBearingHash,
      json.saleOrderLineHash
    ) : null;
  }

  static fromJsonList(list): SaleOrderBearingVisibility[] {
    return (isArray(list)) ? mapCollection(SaleOrderBearingVisibilityBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-bearing-visibility-builder.ts